import { IllustrationProps } from 'fe-design-base/assets/types';
import Box from 'fe-design-base/atoms/Box';

import frying_pan from './imageFiles/frying_pan.png';

const FryingPan = (props: IllustrationProps) => (
  <Box
    w={72}
    {...props}
    minw={72}
    className={`FDBIllustration${
      props?.className ? ` ${props.className}` : ''
    }`}
  >
    <img
      src={frying_pan}
      style={{ width: '100%' }}
      alt="Frying Pan Illustration"
    />
  </Box>
);
export default FryingPan;
